import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    active: Boolean,
    blocked: Boolean,
    url: String,
  }

  connect() {
    this.syncRunButton()
    if (this.activeValue) this.schedule()
  }

  disconnect() {
    window.clearTimeout(this.timer)
  }

  schedule() {
    this.timer = window.setTimeout(() => this.refresh(), 5000)
  }

  syncRunButton() {
    const button = document.querySelector("[data-outbound-run-button]")
    if (!button || button.dataset.setupDisabled === "true") return

    button.disabled = this.activeValue || this.blockedValue
  }

  async refresh() {
    try {
      const response = await fetch(this.urlValue, {
        headers: { Accept: "text/html" },
        credentials: "same-origin",
      })
      if (!response.ok) throw new Error(`Run status request failed: ${response.status}`)

      this.element.outerHTML = await response.text()
    } catch (_error) {
      this.schedule()
    }
  }
}
